import { CallMethodEnums } from '@/types/api';
import {
  AgentActionsResponse,
  MetricsSummary,
  ModelInvocationsResponse,
  TimeRange
} from '@/types/observability';

import { call } from './utils';

export const metricsSummaryGet = async(
  agent: string,
  timeRange: TimeRange = '7d'
): Promise<MetricsSummary> => {
  const params = new URLSearchParams( { agent, time_range: timeRange } );
  return call<unknown, MetricsSummary>( {
    isProtected: true,
    method: CallMethodEnums.GET,
    route: `/api/proxy/observability/api/metrics/summary?${ params.toString() }`
  } );
};

export const modelInvocationsGet = async(
  agent: string,
  page: number = 1,
  pageSize: number = 20,
  timeRange: TimeRange = '7d'
): Promise<ModelInvocationsResponse> => {
  const params = new URLSearchParams( {
    agent,
    page: String( page ),
    page_size: String( pageSize ),
    time_range: timeRange
  } );
  return call<unknown, ModelInvocationsResponse>( {
    isProtected: true,
    method: CallMethodEnums.GET,
    route: `/api/proxy/observability/api/metrics/model-invocations?${ params.toString() }`
  } );
};

export const agentActionsGet = async(
  agent: string,
  page: number = 1,
  pageSize: number = 20,
  timeRange: TimeRange = '7d'
): Promise<AgentActionsResponse> => {
  const params = new URLSearchParams( {
    agent,
    page: String( page ),
    page_size: String( pageSize ),
    time_range: timeRange
  } );
  return call<unknown, AgentActionsResponse>( {
    isProtected: true,
    method: CallMethodEnums.GET,
    route: `/api/proxy/observability/api/metrics/agent-actions?${ params.toString() }`
  } );
};
